import React, { useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as CheckedIcon } from "../../icons/check.circle.fill.svg";
import { ReactComponent as UnCheckedIcon } from "../../icons/check.radio.line.svg";
import LightColors from '../../constants/LightColors';

const CheckboxContainer = styled.div`
  display: inline-flex;
  vertical-align: middle;
  cursor: pointer;
  flex-direction: row;
`;

const Text = styled.div`
  margin-left: 10px;
  color: ${LightColors.textmainlv1}
`

const PriamryRadio = ({ size="md", isChecked, onChanged, text }) => {
  const getSize = () => {
    return size === "md" ? "24px": "32px"
  }
  return (
    <CheckboxContainer onClick={() => onChanged(!isChecked)}>
      {
        isChecked ? <CheckedIcon width={getSize()} height={getSize()} fill={LightColors.primary} /> : <UnCheckedIcon width={getSize()} height={getSize()} stroke={LightColors.textsublv2}/>
      }
      {
        text && <Text>{text}</Text>
      }
    </CheckboxContainer>
  );
};

export default PriamryRadio;
